export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f64f95a7e07ed6768a5b0b009b3408cfd1a76f732&name=fetchTypeahead!'